import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';
import { GetCanonicalsResponseDTO, CanonicalItemDTO } from './dto/canonicals.get.response.dto';

export class CanonicalsService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/canonicals`, client.getTimeout());
  }

  async getList(request?: {
    params?: {
      currentPage?: number;
      limit?: number;
      key?: string;
      resourceId?: string;
      tarkenExtensionId?: string;
    };
    settings?: RetrySettings;
  }): Promise<GetCanonicalsResponseDTO> {
    return (
      await this.client.get<GetCanonicalsResponseDTO>(``, request?.params || {}, {
        bearerToken: await getAuthToken(),
        settings: request?.settings,
      })
    ).data;
  }

  async getById(request: { id: string; settings?: RetrySettings }): Promise<CanonicalItemDTO> {
    return (
      await this.client.get<CanonicalItemDTO>(
        `${request.id}`,
        {},
        {
          bearerToken: await getAuthToken(),
          settings: request.settings,
        },
      )
    ).data;
  }
}
